var Flickity = require("flickity");
require("flickity-fade");

var heroCarouselPlain = new Flickity("#hero-carousel", {
  autoPlay: 4500,
  adaptiveHeight: false,
  pageDots: true,
  prevNextButtons: false,
  cellAlign: "left",
  wrapAround: true,
  contain: true
});